<script setup>
import Layout from "../../layouts/main.vue";
import { onMounted, reactive, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { FormInstance } from "element-plus";
import MethodService from "../../service/MethodService";
import DataForm from "./dataFormUser";
import mushroom from "cem-primary-api";
import Swal from "sweetalert2";
import toastr from "toastr";
import { useI18n } from "vue-i18n";
import { Filter, Project } from "mushroomjs";
const { t } = useI18n();
const ruleFormRef = ref(FormInstance);
import { langWeb } from "../../stores/lang";
const lang_web = langWeb();
const roles = ref([]);
const idAdmin = ref(""); // id của tài khoản admin để kiểm tra khi xóa
let loading = ref(true); // loading
const thresholdMinutes = ref(300); // mặc định là 300s = 5p để tài khoản chuyển trạng thái online/idle/offline
const router = useRouter();
const route = useRoute();
const tableRules = reactive(MethodService.copyObject(DataForm.tableRules));
const validForm = reactive({ value: DataForm.tableRules.dataSearch.valid });
const dataTables = reactive({ value: [] }); // data bảng
const optionsRolesAdmin = ref(MethodService.copyObject(DataForm.optionsRolesAdmin)); // roles tài khoản
const optionsRolesAdminPrimary = ref(MethodService.copyObject(
  DataForm.optionsRolesAdminPrimary,
)); // roles tài khoản
const optionsUser = ref(MethodService.copyObject(DataForm.optionsUser)); // roles tài khoản
const pageSizeDefault = ref(20);
const searchAccountType = ref(""); // số bản ghi mặc định ở phân trang
const statusFilter = ref("");
const fn_handle = (type, scope, row) => {
  if (type == "update") {
    router.push({
      name: "CapNhatTaiKhoan",
      params: { id: row.id },
    });
  }
  if (type == "view") {
    router.push({
      name: "ChiTietTaiKhoan",
      params: { id: row.id },
    });
  }
  if (type == "delete") {
    Swal.fire({
      title: t("t_warning"),
      text: t("t_account_delete"),
      icon: "warning",
      confirmButtonColor: "#f46a6a",
      confirmButtonText: t("swal_accept"),
      cancelButtonText: t("swal_cancel"),
      showCancelButton: true,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await mushroom.user.deleteAsync({
            id: row.id,
          });

          if (response.result) {
            if (idAdmin.value === row.id) {
              toastr.error(t("t_account_not_login"));
              setTimeout(() => {
                let urlLogin = location.origin + "/login";
                window.location.replace(urlLogin);
              }, 2000);
            } else {
              fn_LayDanhSachNguoiDung();
              toastr.success(t("toastr_delete_success"));
            }
          }
        } catch (e) {
          if (e.code === 40001) {
            toastr.error(t("t_cannot_delete_last_admin"));
          } else MethodService.showError(e.code);
        }
      }
    });
  }
};
// hiển thị form tìm kiếm
const fn_showFormTimKiem = () => {
  tableRules.showFormSearch = !tableRules.showFormSearch;
};
// tìm kiếm
const fn_TimKiem = (formEl) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      loading.value = true;
      if (tableRules.dataSearch.value["account"])
        tableRules.dataSearch.value["account"] =
          tableRules.dataSearch.value["account"].trim();

      const dataSearchForApi = {
        value: { ...tableRules.dataSearch.value },
        operator: { ...tableRules.dataSearch.operator },
      };

      tableRules.filters = MethodService.filterTable(
        JSON.stringify(dataSearchForApi),
      );
      if (
        tableRules.dataSearch.value["roles"] &&
        tableRules.dataSearch.value["roles"] === "User"
      ) {
        tableRules.filters += "&roles:nin:Edit,Admin,AdminLocal,TicketManager";
      }
      tableRules.offset = 0;
      tableRules.sort = "";
      fn_LayDanhSachNguoiDung();
    } else return false;
  });
};
// phân trang
const fn_tableSizeChange = (limit) => {
  tableRules.limit = limit;
  pageSizeDefault.value = limit;
  fn_tableChangeOffset(tableRules.page);
};
const fn_tableCurentChange = (page) => {
  fn_tableChangeOffset(page);
};
const fn_tablePrevClick = (page) => {
  fn_tableChangeOffset(page - 1);
};
const fn_tableNextClick = (page) => {
  fn_tableChangeOffset(page + 1);
};
const fn_tableChangeOffset = (page) => {
  tableRules.page = page;
  tableRules.offset = (tableRules.page - 1) * pageSizeDefault.value;
  fn_LayDanhSachNguoiDung();
};
const fn_tableSortChange = (column) => {
  MethodService.tableSortChange(column, tableRules);
  loading.value = true;
  fn_LayDanhSachNguoiDung();
};

const fn_hashUrl = () => {
  MethodService.hashUrl(route.query, tableRules);
  pageSizeDefault.value = tableRules.limit;
};

// chuyển sang màn thêm mới tài khoản
const fn_ThemMoiTaiKhoan = () => {
  router.push({ name: "ThemMoiTaiKhoan" });
};

// lấy toàn bộ danh sách người dùng
const fn_LayDanhSachNguoiDung = async () => {
  router
    .replace({
      name: "DanhSachNguoiDung",
      query: {
        limit: tableRules.limit,
        page: tableRules.page,
        sort: tableRules.sort,
        filters: tableRules.filters,
        showFormSearch: tableRules.showFormSearch,
      },
    })
    .catch(() => {});

  try {
    let userIdsFromSearchAccountType = [];
    let userIdsFromStatusFilter = [];

    // Nếu có filter account_type, query profile trước để lấy danh sách user_id
    if (searchAccountType.value) {
      const profileRes = await mushroom.profile.getAllAsync({
        filters: Filter.eq("account_type", searchAccountType.value).build(),
        fields: "id",
      });
      userIdsFromSearchAccountType = profileRes.result?.map((p) => p.id) || [];
    }

    // Nếu có filter statusFilter, query profile trước (cho các trạng thái online/idle/offline)
    const thresholdMs = thresholdMinutes.value * 1000;
    const now = new Date();
    const cutoff = new Date(now.getTime() - thresholdMs).toISOString();

    if (["online", "idle", "offline"].includes(statusFilter.value)) {
      let profileFilters;

      if (statusFilter.value === "online") {
        // Sử dụng logic: Online là những người hoạt động trong vòng 5 phút (>= cutoff)
        profileFilters = Filter.gte("last_online", cutoff).build();
      } else if (statusFilter.value === "idle") {
        profileFilters = Filter.lt("last_online", cutoff)
          .isNull("last_online", false)
          .build();
      } else if (statusFilter.value === "offline") {
        profileFilters = Filter.isNull("last_online").build();
      }

      const profileRes = await mushroom.profile.getAllAsync({
        filters: profileFilters,
        fields: "id",
      });
      userIdsFromStatusFilter = profileRes.result?.map((p) => p.id) || [];
    }

    let dataFilter = {
      filters: tableRules.filters,
      fields: tableRules.fields,
      limit: tableRules.limit,
      offset: tableRules.offset,
      sort: tableRules.sort,
    };

    // Thêm filter disabled nếu chọn trạng thái cụ thể
    if (statusFilter.value === "block") {
      const blockFilter = Filter.eq("disabled", true).build();
      dataFilter.filters = dataFilter.filters
        ? dataFilter.filters + "&" + blockFilter
        : blockFilter;
    } else if (["online", "idle", "offline"].includes(statusFilter.value)) {
      // Chỉ lấy những user không bị khóa nếu chọn online/idle/offline
      const activeFilter = Filter.eq("disabled", false).build();
      dataFilter.filters = dataFilter.filters
        ? dataFilter.filters + "&" + activeFilter
        : activeFilter;
    }

    // Kết hợp các tập ID từ profile
    let userIds = [];
    if (
      searchAccountType.value &&
      ["online", "idle", "offline"].includes(statusFilter.value)
    ) {
      userIds = userIdsFromSearchAccountType.filter((id) =>
        userIdsFromStatusFilter.includes(id),
      );
      // Nếu có filtering mà kết quả rỗng thì set kết quả rỗng luôn
      if (userIds.length === 0) {
        dataTables.value = [];
        tableRules.total = 0;
        loading.value = false;
        return;
      }
    } else if (searchAccountType.value) {
      userIds = userIdsFromSearchAccountType;
      if (userIds.length === 0) {
        dataTables.value = [];
        tableRules.total = 0;
        loading.value = false;
        return;
      }
    } else if (["online", "idle", "offline"].includes(statusFilter.value)) {
      userIds = userIdsFromStatusFilter;
      if (userIds.length === 0) {
        dataTables.value = [];
        tableRules.total = 0;
        loading.value = false;
        return;
      }
    }

    if (userIds.length > 0) {
      const idFilter = Filter.in("id", userIds).build();
      dataFilter.filters = dataFilter.filters
        ? dataFilter.filters + "&" + idFilter
        : idFilter;
    }

    const response = await mushroom.user.listAsync(dataFilter);
    if (response.result) {
      let dataRoleUser = await getInfoRoleUser(response.result);
      let dataFullNameUser = await getFullNameUsers(dataRoleUser);
      let dataDepartmentUsers = await getDepartmentUsers(dataFullNameUser);
      let _data = await getSubDepartmentUsers(dataDepartmentUsers);
      let finalData = await getPositionUsers(_data);

      dataTables.value = finalData;

      tableRules.total = response.meta.total;
      tableRules.page = response.meta.offset / response.meta.limit + 1;
    }
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loading.value = false;
  }
};
const getInfoRoleUser = (data) => {
  const roleMapping = {
    Admin: "Super Admin",
    AdminPrimary: "Admin",
    AdminLocal: "Admin Local",
    TicketManager: "Ticket Manager",
    QueryAPI: "Query API",
    Monitor: "Monitor",
    Edit: "Edit",
    User: "View",
  };

  const higherRoles = [
    "Admin",
    "AdminPrimary",
    "AdminLocal",
    "TicketManager",
    "Edit",
    "Monitor",
  ];

  data.forEach((item) => {
    let rolesList = item.roles.filter((role) => role !== "NoneWebGUI");

    const hasHigherRole = rolesList.some((role) => higherRoles.includes(role));

    if (hasHigherRole) {
      rolesList = rolesList.filter((role) => role !== "User");
    }

    rolesList.sort((a, b) => {
      if (a === "User") return 1;
      if (b === "User") return -1;
      return 0;
    });

    item.displayRoles = rolesList.map((role) => {
      const name = roleMapping[role] || (role.startsWith("DYN_") ? role.substring(4) : role);
      return {
        name,
        isDynamic: role.startsWith("DYN_")
      };
    });
  });
  return data;
};
const getFullNameUsers = async (data) => {
  if (!data || data.length === 0) return data || [];
  const idsUser = [...new Set(data.map((item) => item.id))];
  try {
    const profileUserArr = await mushroom.profile.getAllAsync({
      filters: Filter.in("id", idsUser).build(),
      fields: Project.include(
        "id",
        "fullname",
        "avatarId",
        "email",
        "phoneNumber",
        "department_id",
        "sub_department_id",
        "position_id",
        "account_type",
        "last_online",
      ).build(),
    });
    if (profileUserArr.result) {
      const profileMap = new Map(profileUserArr.result.map((p) => [p.id, p]));
      data.forEach((item) => {
        const profile = profileMap.get(item.id);
        if (profile) {
          item.fullname = profile.fullname;
          item.department_id = profile.department_id;
          item.sub_department_id = profile.sub_department_id;
          item.position_id = profile.position_id;
          item.account_type = profile.account_type;
          item.last_online = profile.last_online;
        }
      });
    }
  } catch (e) {
    console.error("Error: ", e);
  }
  return data;
};
const getPositionUsers = async (data) => {
  if (!data || data.length === 0) return data || [];
  const idsPosition = [
    ...new Set(
      data.filter((item) => item.position_id).map((item) => item.position_id),
    ),
  ];
  if (idsPosition.length === 0) return data;
  try {
    const positionUserArr = await mushroom.position.getAllAsync({
      filters: Filter.in("id", idsPosition).build(),
    });
    if (positionUserArr.result) {
      const posMap = new Map(positionUserArr.result.map((p) => [p.id, p.name]));
      data.forEach((item) => {
        if (item.position_id && posMap.has(item.position_id)) {
          item.position_name = posMap.get(item.position_id);
        }
      });
    }
  } catch (e) {
    console.error("Error: ", e);
  }
  return data;
};
const getDepartmentUsers = async (data) => {
  if (!data || data.length === 0) return data || [];
  const idsDepartment = [
    ...new Set(
      data
        .filter((item) => item.department_id)
        .map((item) => item.department_id),
    ),
  ];
  if (idsDepartment.length === 0) return data;
  try {
    const departmentUserArr = await mushroom.department.getAllAsync({
      filters: Filter.in("id", idsDepartment).build(),
    });
    if (departmentUserArr.result?.length > 0) {
      const deptMap = new Map(
        departmentUserArr.result.map((d) => [d.id, d.name]),
      );
      data.forEach((item) => {
        if (item.department_id && deptMap.has(item.department_id)) {
          item.department_name = deptMap.get(item.department_id);
        }
      });
    }
  } catch (e) {
    console.error("Error: ", e);
  }
  return data;
};

const getSubDepartmentUsers = async (data) => {
  if (!data || data.length === 0) return data || [];
  const idsSubDepartment = [
    ...new Set(
      data
        .filter((item) => item.sub_department_id)
        .map((item) => item.sub_department_id),
    ),
  ];
  if (idsSubDepartment.length === 0) return data;
  try {
    const subDepartmentUserArr = await mushroom.sub_department.getAllAsync({
      filters: Filter.in("id", idsSubDepartment).build(),
    });
    if (subDepartmentUserArr.result?.length > 0) {
      const subMap = new Map(
        subDepartmentUserArr.result.map((s) => [s.id, s.name]),
      );
      data.forEach((item) => {
        if (item.sub_department_id && subMap.has(item.sub_department_id)) {
          item.sub_department_name = subMap.get(item.sub_department_id);
        }
      });
    }
  } catch (e) {
    console.error("Error: ", e);
  }
  return data;
};

watch(
  () => lang_web.showLang,
  () => {
    optionsUser.value = MethodService.copyObject(DataForm.optionsUser);
  },
);

const getOnlineThreshold = async () => {
  try {
    const res = await mushroom.system_config.listAsync({
      filters: Filter.eq("key", "online_threshold_time").build(),
    });
    if (res.result?.length > 0) {
      const val = Number(res.result[0].value);
      if (!isNaN(val) && val > 0) thresholdMinutes.value = val;
    }
  } catch (e) {
    console.error("Lỗi gọi system_config online_threshold_time: ", e);
  }
};

const getUserOnlineStatus = (lastOnline) => {
  if (!lastOnline) return "offline";
  const time = new Date(lastOnline).getTime();
  if (isNaN(time)) return "offline";
  const diff = Date.now() - time;
  const thresholdMs = thresholdMinutes.value * 1000;
  return diff <= thresholdMs ? "online" : "idle";
};

const getDynamicRolesForSearch = async () => {
  try {
    const response = await mushroom.user_role_dynamic.getAllAsync({
      fields: "id,name",
    });
    if (response.result) {
      response.result.forEach((item) => {
        const option = {
          value: item.name,
          label: item.name.startsWith("DYN_") ? item.name.substring(4) : item.name
        };
        optionsRolesAdmin.value.push(option);
        optionsRolesAdminPrimary.value.push(option);
      });
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

onMounted(async () => {
  fn_hashUrl();
  await getOnlineThreshold();
  await getDynamicRolesForSearch();
  await fn_LayDanhSachNguoiDung();
  const response = JSON.parse(localStorage.getItem("userInfo"));
  roles.value = response.result.roles;
  idAdmin.value = response.result.id;
});
</script>

<template>
  <Layout>
    <div class="card" style="min-height: 80vh">
      <div class="card-header">
        <h3 class="text-uppercase mb-0">{{ $t("t-list-users") }}</h3>
        <div class="text-end">
          <div class="btn-header">
            <button
              class="btn btn-soft-secondary btn-border me-2"
              @click="fn_showFormTimKiem()"
            >
              <i class="ri-search-line"></i>
              {{ $t("t-search") }}
            </button>
            <button
              class="btn btn-secondary btn-border"
              @click="fn_ThemMoiTaiKhoan"
              v-if="roles.includes('Admin') || roles.includes('AdminPrimary')"
            >
              <i class="ri-add-circle-line"></i>
              {{ $t("t-add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="padding: 0 0 15px 0">
        <div class="main-body">
          <div class="main-body-search mx-3 mb-3">
            <b-collapse
              v-model="tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card>
                <el-form
                  label-position="top"
                  ref="ruleFormRef"
                  @submit.prevent
                  :rules="validForm.value"
                  :model="tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item :label="$t('t-account')">
                        <el-input
                          clearable
                          size="large"
                          v-model="tableRules.dataSearch.value['account']"
                          :placeholder="$t('t-place-account')"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item :label="$t('t-roles-account')">
                        <el-select
                          :placeholder="$t('t-place-roles-account')"
                          clearable
                          size="large"
                          v-model="tableRules.dataSearch.value['roles']"
                          style="width: 100%"
                          v-if="roles.includes('Admin')"
                        >
                          <el-option
                            v-for="item in optionsRolesAdmin"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <el-select
                          :placeholder="$t('t-place-roles-account')"
                          clearable
                          size="large"
                          v-model="tableRules.dataSearch.value['roles']"
                          style="width: 100%"
                          v-else
                        >
                          <el-option
                            v-for="item in optionsRolesAdminPrimary"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item :label="$t('t_type_account')">
                        <el-select
                          :placeholder="$t('t_please_choose_account_type')"
                          clearable
                          size="large"
                          v-model="searchAccountType"
                          style="width: 100%"
                        >
                          <el-option
                            value="system"
                            :label="$t('t_type_account_system')"
                          />
                          <el-option
                            value="ldap"
                            :label="$t('t_type_account_ldap')"
                          />
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item :label="$t('t-state-account')">
                        <el-select
                          :placeholder="$t('t-state-account')"
                          clearable
                          size="large"
                          v-model="statusFilter"
                          style="width: 100%"
                        >
                          <el-option value="" :label="$t('t_all')" />
                          <el-option
                            value="online"
                            :label="$t('t_user_status_online')"
                          />
                          <el-option
                            value="idle"
                            :label="$t('t_user_status_idle')"
                          />
                          <el-option
                            value="offline"
                            :label="$t('t_user_status_offline')"
                          />
                          <el-option
                            value="block"
                            :label="$t('t-block-user')"
                          />
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="&nbsp;">
                        <a
                          class="btn btn-soft-secondary btn-border mx-3"
                          style="width: 80px"
                          @click="fn_showFormTimKiem()"
                        >
                          {{ $t("t-hide") }}
                        </a>
                        <button
                          class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                          style="width: 100px"
                          native-type="submit"
                          type="submit"
                          @click="fn_TimKiem(ruleFormRef)"
                        >
                          {{ $t("t-search") }}
                        </button>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="mb-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:page-size="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
          <el-table
            size="small"
            :data="dataTables.value"
            style="width: 100%"
            min-height="550"
            v-loading="loading"
            @sort-change="fn_tableSortChange"
            :default-sort="{
              prop: tableRules.defaultSort[0],
              order: tableRules.defaultSort[1],
            }"
          >
            <el-table-column
              prop=""
              :label="$t('t-stt')"
              width="50"
              align="center"
            >
              <template #default="scope">
                <div class="text-center">
                  {{ tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="account"
              :label="$t('t-account')"
              min-width="140"
              header-align="center"
              align="start"
              :sortable="true"
            />
            <el-table-column
              prop="fullname"
              :label="$t('t_full_name')"
              min-width="140"
              header-align="center"
              align="start"
            />
            <el-table-column
              prop="position_name"
              :label="$t('t_position_name')"
              width="120"
              align="start"
              header-align="center"
              show-overflow-tooltip
            >
              <template #default="scope">
                <div class="col-tooltip">
                  {{ scope.row.position_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="sub_department_name"
              :label="$t('t_sub_department')"
              width="130"
              header-align="center"
              align="start"
              show-overflow-tooltip
            >
              <template #default="scope">
                <div class="col-tooltip">
                  {{ scope.row.sub_department_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="department_name"
              :label="$t('t-departments')"
              width="140"
              align="start"
              header-align="center"
            />
            <el-table-column
              prop="roles"
              :label="$t('t-roles-account')"
              min-width="165"
              align="center"
              header-align="center"
            >
              <template #default="scope">
                <span
                  v-for="(role, index) in scope.row.displayRoles"
                  :key="index"
                  class="badge text-uppercase me-1"
                  :class="{
                    'badge-soft-secondary': role.name === 'Super Admin',
                    'badge-soft-danger': role.name === 'Admin',
                    'badge-soft-success': role.name === 'Admin Local',
                    'badge-soft-info': role.name === 'Edit',
                    'badge-soft-warning': role.name === 'View',
                    'badge-soft-primary': role.name === 'Query API',
                    'badge-soft-dark': role.name === 'NoneWebGUI',
                    'badge-ticket-manager': role.name === 'Ticket Manager',
                    'badge-dynamic-role': role.isDynamic,
                    'badge-monitor': role.name === 'Monitor',
                  }"
                  >{{ role.name }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="account_type"
              :label="$t('t_type_account')"
              width="115"
              align="center"
            >
              <template #default="scope">
                <span
                  v-if="scope.row.account_type === 'ldap'"
                  class="badge badge-soft-danger text-uppercase"
                  >{{ $t("t_type_account_ldap") }}</span
                >
                <span
                  v-else-if="scope.row.account_type === 'system'"
                  class="badge badge-soft-secondary text-uppercase"
                  >{{ $t("t_type_account_system") }}</span
                >
                <span v-else class="badge badge-soft-dark text-uppercase"
                  >-</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="disabled"
              :label="$t('t-state-account')"
              align="center"
              width="90"
            >
              <template #default="scope">
                <div
                  class="d-flex align-items-center justify-content-center gap-2"
                >
                  <el-tooltip
                    v-if="scope.row.disabled === true"
                    effect="light"
                    :content="$t('t-block-user')"
                    placement="top"
                  >
                    <span
                      class="status-account-badge status-account-badge--blocked status-account-badge--circle"
                    >
                      <i class="ri-subtract-fill"></i>
                    </span>
                  </el-tooltip>
                  <el-tooltip
                    v-else
                    effect="light"
                    :content="
                      getUserOnlineStatus(scope.row.last_online) === 'online'
                        ? $t('t_user_status_online')
                        : getUserOnlineStatus(scope.row.last_online) === 'idle'
                        ? $t('t_user_status_idle')
                        : $t('t_user_status_offline')
                    "
                    placement="top"
                  >
                    <span
                      class="status-dot-table"
                      :class="{
                        'status-dot-table--online':
                          getUserOnlineStatus(scope.row.last_online) ===
                          'online',
                        'status-dot-table--idle':
                          getUserOnlineStatus(scope.row.last_online) === 'idle',
                        'status-dot-table--offline':
                          getUserOnlineStatus(scope.row.last_online) ===
                          'offline',
                      }"
                    ></span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('t-action')"
              align="center"
              width="120px"
            >
              <template #default="scope">
                <div class="btn-group-thao-tac">
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_view')"
                    placement="top"
                  >
                    <button
                      v-if="
                        roles.includes('Admin') ||
                        roles.includes('AdminPrimary') ||
                        roles.includes('AdminLocal')
                      "
                      type="button"
                      class="btn btn-soft-info waves-effect waves-light btn-sm"
                      @click="fn_handle('view', scope.$index, scope.row)"
                    >
                      <i class="ri-eye-line"></i>
                    </button>
                  </el-tooltip>

                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_option')"
                    placement="top"
                  >
                    <button
                      v-if="
                        roles.includes('Admin') ||
                        roles.includes('AdminPrimary')
                      "
                      type="button"
                      class="btn btn-soft-success waves-effect waves-light btn-sm"
                      @click="fn_handle('update', scope.$index, scope.row)"
                    >
                      <i class="ri-edit-box-line"></i>
                    </button>
                  </el-tooltip>

                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_delete')"
                    placement="top"
                  >
                    <button
                      v-if="
                        roles.includes('Admin') ||
                        roles.includes('AdminPrimary')
                      "
                      type="button"
                      class="btn btn-soft-danger waves-effect waves-light btn-sm"
                      @click="fn_handle('delete', scope.$index, scope.row)"
                    >
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:page-size="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<link type="scss" src="./nguoidung.scss" />
<style scoped>
.status-account-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  font-size: 10px;
  line-height: 1;
  color: #fff;
  pointer-events: auto;
  cursor: default;
}
.status-account-badge--active {
  background-color: #0ab39c;
}
.status-account-badge--blocked {
  background-color: #f06548;
}
.status-account-badge--circle {
  border-radius: 50% !important;
}
.status-dot-table {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.status-dot-table--online {
  background-color: #0ab39c;
}
.status-dot-table--idle {
  background-color: #f7b84b;
}
.status-dot-table--offline {
  background-color: #909399;
}
.badge-dynamic-role {
  background-color: #e9ecef;
  color: #6c757d;
}
</style>
